export class StudentCourseTeacherOptionModel {
	teacher_uid: number;
	teacher_name: string;
}
